module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-5.6318bb87.png";